import React, { useEffect, useState } from "react";
import Overview from "./sections/Overview";
import UnusedDashboards from "./sections/UnusedDashboards";
import DashboardAdmin from "./sections/DashboardAdmin";
import AccessRequests from "./sections/AccessRequests";
import Header from "../Header";

// receive props currentTheme
const Admin = ({ theme }) => {
  // change all state to true and abbly view to tabs
  const [expandedSections, setExpandedSections] = useState({
    overview: true, 
    unused: true,
    admin: true,
    access: true,
  });
  const [activeTab, setActiveTab] = useState('overview');
  const [runAs] = useState("admin");

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Header theme={theme} title="Admin Panel" />

      <div className=" mx-auto py-6 px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="bg-white shadow rounded-lg mb-6 p-6">
          <h1 className="text-xl font-bold text-gray-700">
           Welcome to the Dashboard Owners Panel!
          </h1>
        {/* <p className="mt-2 text-gray-600">Welcome to the Dashboard Owners Panel!</p> */}
        </div>
        {/* Old view */}

            {/* <Overview
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              runAs={runAs}
            />
          
            <UnusedDashboards
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              runAs={runAs}
            />

            <DashboardAdmin
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              runAs={runAs}
            />

            <AccessRequests
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              runAs={runAs}
            /> */}

     {/* [New] Tabs Navigation */}
        <div className="bg-white shadow rounded-lg overflow-hidden mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                onClick={() => handleTabChange('overview')}
                className={`py-4 px-6 text-center border-b-2 text-md flex-1 ${
                  activeTab === 'overview'
                    ? `!font-bold`
                    : 'border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700'
                }`}
                style={activeTab === 'overview' ? { borderBottom: `2px solid ${theme.leftNavBackgroundColor}`, color: theme.leftNavBackgroundColor } : {}}
              >
                Dashboard Usage {runAs === 'admin' ? ' - Last 90 Days' : ''}
              </button>
              <button
                onClick={() => handleTabChange('unused')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === 'unused'
                    ? `!font-bold`
                    : 'border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700'
                }`}
                style={activeTab === 'unused' ? { borderBottom: `2px solid ${theme.leftNavBackgroundColor}`, color: theme.leftNavBackgroundColor } : {}}
              >
                Unused Dashboards
              </button>
              <button
                onClick={() => handleTabChange('admin')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === 'admin'
                    ? `!font-bold`
                    : 'border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700'
                }`}
                style={activeTab === 'admin' ? { borderBottom: `2px solid ${theme.leftNavBackgroundColor}`, color: theme.leftNavBackgroundColor } : {}}
              >
                Dashboards Admin
              </button>
              <button
                onClick={() => handleTabChange('access')}
                className={`py-4 px-6 text-center border-b-2 font-medium text-md flex-1 ${
                  activeTab === 'access'
                     ? `!font-bold`
                    : 'border-transparent text-gray-700 hover:text-gray-700 hover:border-gray-700'
                }`}
                style={activeTab === 'access' ? { borderBottom: `2px solid ${theme.leftNavBackgroundColor}`, color: theme.leftNavBackgroundColor } : {}}
              >
                Access Requests
              </button>
            </nav>
          </div>
        </div>
        
        {/* Tab Content */}
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="p-6">
            {activeTab === 'overview' && (
              <Overview 
                expandedSections={expandedSections} 
                toggleSection={toggleSection} 
                runAs={runAs}
                theme={theme} // Pass the theme object
              />
            )}
            
            {activeTab === 'unused' && (
              <UnusedDashboards 
                expandedSections={expandedSections} 
                toggleSection={toggleSection} 
                runAs={runAs}
                theme={theme}     // Pass the theme object
              />
            )}
            
            {activeTab === 'admin' && (
              <DashboardAdmin 
                expandedSections={expandedSections} 
                toggleSection={toggleSection} 
                runAs={runAs}
                theme={theme} // Pass the theme object
              />
            )}
            
            {activeTab === 'access' && (
              <AccessRequests 
                expandedSections={expandedSections} 
                toggleSection={toggleSection} 
                runAs={runAs}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
